export default function icurrency (number) {
    return parseFloat(number).toLocaleString('es-MX', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    })
};